import React from 'react';
import { Link } from 'react-router-dom';

const SLBSLogo = ({ variant = 'full', className = '', linkTo = '/', isFooter = false }) => {
  // Use the uploaded logo image
  const logoSrc = '/slbs-logo-correct.png';

  // Icon Only (square sakura flower part)
  const IconOnly = () => (
    <div 
      className={`overflow-hidden ${className || 'w-12 h-12'}`}
      style={{ backgroundColor: '#F7C9D3' }}
    >
      <img 
        src={logoSrc}
        alt="Sakura Local Business Support logo"
        className="w-full h-full object-cover"
        style={{ 
          objectFit: 'cover',
          objectPosition: 'center 20%' // Show only the flower icon
        }}
      />
    </div>
  );

  // Full Logo with Japanese text (square icon + Japanese text)
  const FullLogo = () => (
    <div className={`flex items-center space-x-2 ${className}`}>
      <div 
        className="w-12 h-12 overflow-hidden flex-shrink-0"
        style={{ backgroundColor: '#F7C9D3' }}
      >
        <img 
          src={logoSrc}
          alt="Sakura Local Business Support logo"
          className="w-full h-full object-cover"
          style={{ 
            objectFit: 'cover',
            objectPosition: 'center 20%'
          }}
        />
      </div>
      <span 
        className={isFooter ? "font-bold text-xl" : "font-semibold text-xl"} 
        style={{ color: isFooter ? '#FFFFFF' : '#2C2C2C' }}
      >
        さくらローカルビジネスサポート
      </span>
    </div>
  );

  // Compact Logo (square icon + abbreviated text)
  const CompactLogo = () => (
    <div className={`flex items-center space-x-2 ${className}`}>
      <div 
        className="w-10 h-10 overflow-hidden flex-shrink-0"
        style={{ backgroundColor: '#F7C9D3' }}
      >
        <img 
          src={logoSrc}
          alt="Sakura Local Business Support logo"
          className="w-full h-full object-cover"
          style={{ 
            objectFit: 'cover',
            objectPosition: 'center 20%'
          }}
        />
      </div>
      <span 
        className={isFooter ? "font-bold" : "font-semibold"} 
        style={{ color: isFooter ? '#FFFFFF' : '#2C2C2C' }}
      >
        さくらローカルビジネスサポート
      </span>
    </div>
  );

  const renderLogo = () => {
    switch (variant) {
      case 'icon':
        return <IconOnly />;
      case 'compact':
        return <CompactLogo />;
      case 'full':
      default:
        return <FullLogo />;
    }
  };

  if (linkTo) {
    return (
      <Link to={linkTo} className="inline-block">
        {renderLogo()}
      </Link>
    );
  }

  return renderLogo();
};

export default SLBSLogo;
